import {getRolesPantalla} from '@/utils/funtionsGlobals';

export default [
  {
    path: '/AgruparView',
    name: 'AgruparView',
    component: () =>
      import(
        '../views/agrupar/AgruparView.vue'),
    meta: {
      title: 'Agrupar',
      requiresAuthentication: true,
      requiresAuthorization: false,
      roles: getRolesPantalla('AgruparView'),
      bread: {
        path: [
          'Registros',
        ],
      },
    },
  },
];
